var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { Offline as OfflineIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { QueryClientProvider } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import axiosRetry from 'axios-retry';
import dayjs from 'dayjs';
import { Cookies } from 'react-cookie';
import 'dayjs/locale/ko';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga';
import { API_URLS } from '@tving/utils/src/constants/apiConstants';
import { CACHE_KEY, DEVICE_TYPE, TV_PAGE } from '@tving/utils/src/constants/commonConstants';
import { QUERY_CLIENT } from '@tving/utils/src/constants/queryConstants';
import initAmplitude from '@tving/utils/src/utils/amplitude/initAmplitude';
import { API_KEY, API_SERVER_URL, GATEWAY_URL, API_TYPES, SCREEN_CODE, AMPLITUDE_KEY } from '@tving/utils/src/utils/common/apiConfig';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
import isRequiredAccessTokenApi from '@tving/utils/src/utils/common/isRequiredAccessTokenApi/isRequiredAccessTokenApi';
import DeviceManagerInstance from '@tving/utils/src/utils/device';
import axiosInstance from '@tving/utils/src/utils/http';
import TvingFocusable from '@tving/utils/src/utils/tving-focusable/TvingFocusable';
import TvingLogModule from '@tving/utils/src/utils/tving-log-module/TvingLogModule';
import App from '@/App';
import { EventDelegator, PageNavigator } from '@/index';
import { createAccessTokenApi } from '@/util/createAccessTokenApi';
import packageJson from '../package.json';
import './index.scss';
window.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var __webpack_get_script_filename_old__, deviceType, environment, playerApiType, isPlayerDebugConsole, cookies, version, sentryErrorWhitelist, _a, appVersion, deviceModel, appWebVersion, dimension12, handleDeeplink, rootDOM;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                __webpack_get_script_filename_old__ = __webpack_get_script_filename__;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // eslint-disable-next-line camelcase
                __webpack_get_script_filename__ = function (chunk) {
                    var src = __webpack_get_script_filename_old__(chunk);
                    var chunkRetryCount = localStorage.getItem(CACHE_KEY.CHUNK_RETRY_COUNT);
                    if (chunkRetryCount) {
                        return "".concat(src, "?chunk-retry-count=").concat(chunkRetryCount);
                    }
                    return "".concat(src);
                };
                deviceType = getDeviceType();
                environment = (_b = process.env.REACT_APP_RELEASE) !== null && _b !== void 0 ? _b : 'PRODUCTION';
                playerApiType = environment === API_TYPES.PRODUCTION ? 'real' : environment.toLowerCase();
                isPlayerDebugConsole = localStorage.getItem(CACHE_KEY.TVING_PLAYER_DEBUG_CONSOLE) === '1';
                cookies = new Cookies();
                if (deviceType === DEVICE_TYPE.ANDROIDTV) {
                    if (isPlayerDebugConsole || playerApiType !== 'real') {
                        document.body.classList.add('androidtv');
                    }
                }
                version = packageJson.version + (environment === 'PRODUCTION' ? '' : ".".concat(environment));
                sentryErrorWhitelist = [
                    'The play() request was interrupted by a call to pause()',
                    "Unexpected token '<'",
                    'g.readyState',
                    "Cannot read property 'state' of undefined",
                    'createObjectStore',
                ];
                Sentry.init({
                    dsn: 'https://a43bc329a7ab4711b4fa3116bf2fe1ae@tracking.tving.com/15',
                    integrations: [
                        new Integrations.BrowserTracing({
                            tracePropagationTargets: ['localhost'],
                        }),
                        new OfflineIntegration({
                            // limit how many events will be localled saved. Defaults to 30.
                            maxStoredEvents: 30,
                        }),
                        new Sentry.Integrations.TryCatch({
                            eventTarget: false,
                        }),
                    ],
                    release: version,
                    environment: process.env.REACT_APP_RELEASE,
                    beforeSend: function (event, hint) {
                        var _a, _b, _c;
                        if (window.location.hostname === 'localhost' || window.location.hostname === 'l.tving.com') {
                            return null;
                        }
                        var value = (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value;
                        if (value) {
                            var isWhitelist_1 = false;
                            sentryErrorWhitelist.forEach(function (error) {
                                if (value.includes(error)) {
                                    isWhitelist_1 = true;
                                }
                            });
                            if (isWhitelist_1) {
                                return null;
                            }
                        }
                        var originalException = hint === null || hint === void 0 ? void 0 : hint.originalException;
                        if (originalException && typeof originalException !== 'string') {
                            var name_1 = originalException.name, message_1 = originalException.message;
                            var isWhitelist_2 = false;
                            sentryErrorWhitelist.forEach(function (error) {
                                if (name_1 && name_1.includes(error)) {
                                    isWhitelist_2 = true;
                                }
                                if (message_1 && message_1.includes(error)) {
                                    isWhitelist_2 = true;
                                }
                            });
                            if (isWhitelist_2) {
                                return null;
                            }
                        }
                        return event;
                    },
                    // Set tracesSampleRate to 1.0 to capture 100%
                    // of transactions for performance monitoring.
                    // We recommend adjusting this value in production
                    tracesSampleRate: 1,
                });
                dayjs.locale('ko');
                return [4 /*yield*/, DeviceManagerInstance.init()];
            case 1:
                _c.sent();
                _a = DeviceManagerInstance.getDeviceInfo(), appVersion = _a.appVersion, deviceModel = _a.deviceModel, appWebVersion = _a.appWebVersion;
                axiosInstance.defaults.timeout = 5000;
                axiosInstance.defaults.params = {
                    screenCode: SCREEN_CODE,
                    networkCode: 'CSND0900',
                    osCode: 'CSOD0900',
                    teleCode: 'CSCD0900',
                    apiKey: API_KEY,
                    pocType: 
                    // eslint-disable-next-line no-nested-ternary
                    deviceType === DEVICE_TYPE.WEBOS
                        ? "APP_W_TVING_".concat(appVersion)
                        : deviceType === DEVICE_TYPE.TIZEN
                            ? "APP_Z_TVING_".concat(appVersion)
                            : "APP_X_TVING_".concat(appVersion),
                };
                axiosRetry(axiosInstance, {
                    retries: 3,
                    retryCondition: function () { return true; },
                    shouldResetTimeout: true,
                    retryDelay: function (retryCount, error) {
                        TvingLogModule.warn("Retry: ".concat(retryCount, ", URL: ").concat(error.config.url, ", ").concat(error.config.headers ? "HEADER : ".concat(JSON.stringify(error.config.headers)) : ''));
                        return retryCount * 250; // 횟수마다 retryDelay 증가
                    },
                });
                /**
                 * axios request interceptors
                 */
                axiosInstance.interceptors.request.use(function (requestConfig) { return __awaiter(void 0, void 0, void 0, function () {
                    var convertedRequestConfig, url, accessToken, refreshToken, authToken, tvingToken, urlPath;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                convertedRequestConfig = requestConfig;
                                url = convertedRequestConfig.url;
                                accessToken = localStorage.getItem(CACHE_KEY.ACCESS_TOKEN) || cookies.get(CACHE_KEY.ACCESS_TOKEN);
                                refreshToken = localStorage.getItem(CACHE_KEY.REFRESH_TOKEN) || cookies.get(CACHE_KEY.REFRESH_TOKEN);
                                authToken = localStorage.getItem(CACHE_KEY.AUTH_TOKEN) || cookies.get(CACHE_KEY.AUTH_TOKEN);
                                tvingToken = localStorage.getItem(CACHE_KEY.TVING_TOKEN) || cookies.get(CACHE_KEY.TVING_TOKEN);
                                urlPath = url.split(GATEWAY_URL)[1] || '';
                                if (!url.includes(API_SERVER_URL)) return [3 /*break*/, 1];
                                if (authToken) {
                                    convertedRequestConfig.headers = __assign(__assign({}, convertedRequestConfig.headers), { 'Auth-Token': authToken });
                                }
                                return [3 /*break*/, 4];
                            case 1:
                                if (!url.includes(GATEWAY_URL)) return [3 /*break*/, 4];
                                // AccessToken, RefreshToken 이 없을때 로그아웃 처리
                                if (!accessToken && !refreshToken && !authToken && !tvingToken && isRequiredAccessTokenApi(urlPath)) {
                                    PageNavigator.reset('/logout');
                                    return [2 /*return*/, Promise.reject()];
                                }
                                if (!(!accessToken && refreshToken && isRequiredAccessTokenApi(urlPath))) return [3 /*break*/, 3];
                                return [4 /*yield*/, createAccessTokenApi(refreshToken)];
                            case 2:
                                accessToken = _a.sent();
                                _a.label = 3;
                            case 3:
                                if (accessToken && authToken && tvingToken && isRequiredAccessTokenApi(urlPath) && !urlPath.includes(API_URLS.AUTO_LOGIN)) {
                                    // header 에 빠져야할 urls
                                    convertedRequestConfig.headers = __assign(__assign({}, convertedRequestConfig.headers), { 'Auth-Token': authToken, 'Access-Token': accessToken, Authorization: "Bearer ".concat(encodeURIComponent(tvingToken)) });
                                }
                                else if (authToken && tvingToken && urlPath.includes(API_URLS.AUTO_LOGIN)) {
                                    if (accessToken) {
                                        // header 에 빠져야할 urls
                                        convertedRequestConfig.headers = __assign(__assign({}, convertedRequestConfig.headers), { 'Auth-Token': authToken, 'Access-Token': accessToken });
                                    }
                                    else {
                                        // header 에 빠져야할 urls
                                        convertedRequestConfig.headers = __assign(__assign({}, convertedRequestConfig.headers), { 'Auth-Token': authToken });
                                    }
                                }
                                _a.label = 4;
                            case 4: return [2 /*return*/, convertedRequestConfig];
                        }
                    });
                }); }, function (error) {
                    // 오류 요청을 보내기전 수행할 일
                    return Promise.reject(new AxiosError(error));
                });
                /**
                 * axios response 기본 인터셉터
                 */
                axiosInstance.interceptors.response.use(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                    var tvingResponse, status, refreshToken;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                tvingResponse = response.data;
                                status = (_a = tvingResponse === null || tvingResponse === void 0 ? void 0 : tvingResponse.header) === null || _a === void 0 ? void 0 : _a.status;
                                if (!response.config.url.includes(API_SERVER_URL)) return [3 /*break*/, 1];
                                // 로그인 API 일경우 401, 302 되더라도 무시( 아래 처리 불필요)
                                if (status === 401) {
                                    QUERY_CLIENT.invalidateQueries(['profile'])
                                        .then(function () {
                                        var _a;
                                        if ((_a = response.config.url) === null || _a === void 0 ? void 0 : _a.includes(API_URLS.PROFILE_LIST)) {
                                            TvingLogModule.warn("[Custom Error] API Send Response - 401(logout)", {
                                                requestUrl: response.config.url,
                                            });
                                            PageNavigator.reset('/logout');
                                        }
                                        else {
                                            TvingLogModule.warn("[Custom Error] API Send Response - 401(profile list)", {
                                                requestUrl: response.config.url,
                                            });
                                            PageNavigator.reset('/profile/list');
                                        }
                                    })
                                        .catch(function () { return null; });
                                }
                                else if (status && status >= 400) {
                                    TvingLogModule.error("Http Status is OK! But tving Status is ERROR: ".concat(response.config.url, "}"), {
                                        response: JSON.stringify(tvingResponse),
                                    });
                                    return [2 /*return*/, Promise.reject(new AxiosError("Http Status is OK! But tving Status is ERROR: ".concat(response.config.url, " ").concat(JSON.stringify(tvingResponse)), status.toString()))];
                                }
                                return [3 /*break*/, 3];
                            case 1:
                                if (!response.config.url.includes(GATEWAY_URL)) return [3 /*break*/, 3];
                                if (!(JSON.stringify(tvingResponse) === '4000')) return [3 /*break*/, 3];
                                TvingLogModule.error('axiosInstance.interceptors.response :: ', response, response.data);
                                refreshToken = localStorage.getItem(CACHE_KEY.REFRESH_TOKEN);
                                return [4 /*yield*/, createAccessTokenApi(refreshToken)];
                            case 2:
                                _b.sent();
                                _b.label = 3;
                            case 3: return [2 /*return*/, response];
                        }
                    });
                }); }, function (error) {
                    var _a, _b;
                    if (error.config.url.includes(GATEWAY_URL)) {
                        var errorCode = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) || '';
                        if (errorCode === '401') {
                            // 로그아웃
                            PageNavigator.reset('/logout');
                        }
                    }
                    // 에러처리 공통
                    return Promise.reject(error);
                });
                Object.values(TV_PAGE).forEach(function (page) {
                    var tvingFocusable = TvingFocusable.getInstance(page);
                    tvingFocusable.initTvingFocusable({
                        throttle: deviceType === DEVICE_TYPE.WEB ? 0 : 400,
                    });
                });
                EventDelegator.registerAll();
                ReactGA.initialize('UA-118660069-1');
                initAmplitude({ ApiKey: AMPLITUDE_KEY });
                switch (deviceType) {
                    case DEVICE_TYPE.WEBOS:
                        dimension12 = 'LGTV';
                        break;
                    case DEVICE_TYPE.TIZEN:
                        dimension12 = 'SSTV';
                        break;
                    case DEVICE_TYPE.ANDROIDTV:
                        dimension12 = "AOSTV".concat(appVersion);
                        break;
                    default:
                        dimension12 = 'WEB';
                }
                ReactGA.set({ dimension12: dimension12 });
                // 61: model name
                ReactGA.set({ dimension61: deviceModel });
                // 67: appWeb version
                ReactGA.set({ dimension67: appWebVersion });
                handleDeeplink = function (mediaCode) {
                    if (mediaCode) {
                        PageNavigator.push("/detail/".concat(mediaCode));
                    }
                };
                DeviceManagerInstance.deeplink(handleDeeplink);
                rootDOM = document.getElementById('root');
                if (rootDOM) {
                    ReactDOM.createRoot(rootDOM).render(_jsx(Sentry.ErrorBoundary, { children: _jsx(QueryClientProvider, __assign({ client: QUERY_CLIENT }, { children: _jsx(App, {}) })) }));
                }
                else {
                    throw new Error('rootDOM is not found');
                }
                return [2 /*return*/];
        }
    });
}); };
